import React, {useState, useEffect} from 'react';
import "./InfoPart.scss";
import CountUp from 'react-countup';

export default function InfoPart() {
    const [start, setStart] = useState(false)
    //Intersection Observer part
  useEffect(() => {
    //Sets the Observer options
    const options = {
      root: null, // The view port
      threshhold: 0, // 0 ~ 1
      rootMargin: "-120px", // like margin in css
    };
    const observer = new IntersectionObserver(function (entries, observer) {
      entries.forEach((entry) => {
        console.log(entry);
        if (!entry.isIntersecting) return;
        entry.target.classList.value === "date watch" && setStart(true)
        entry.target.children.forEach((node) => node.classList.add("active"))
        
      });
    }, options);
      const wantedNodes = document.querySelectorAll(".watch");
      wantedNodes.forEach((li) => {
        observer.observe(li);
      });
  }, []);


    return (
        <section className="info-page">
            <div className="years watch">
                <div className="helicopter"></div>
            </div>
            <div className="fallens ">
                <div className="soldier1"></div>
                <div className="soldier2"></div>
                <div className="soldier3"></div>
            </div>
            <div className="outpost watch">
                <div className="motsav1 single"></div>
                <div className="motsav2 single"></div>
                <div className="motsav3 single"></div>
                <div className="motsav4 single"></div>
                {/* <div className="motsav5 single"></div> */}
                {/* <div className="motsav6 single"></div> */}
                {/* <div className="motsav7 single"></div>
                <div className="motsav8 single"></div> */}
            </div>
            <div className="date watch">
                <div className="date_wrapper">
                    {start && <CountUp start={10} end={24} duration={4}/>}
                </div>
            </div>
        </section>
    )
}
